import * as React from "react"

import { createNavigator, MoveHandle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderFunction, NavigatorProps } from "Catalog/Edit/shared/components/Navigator/types"
import useOptionListUsages from "Catalog/Edit/shared/hooks/useOptionListUsages"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { OptionListId } from "shared/hubrise/ids"
import { IOptionList } from "shared/hubrise/models"

import { StyledOptionList, Name, Usage } from "./Styles"

interface OptionListProps {
  items: Array<IOptionList>
  selectedId?: OptionListId
}

const OptionListNavigator = createNavigator<IOptionList>()

const Navigator = ({ items, selectedId }: OptionListProps): JSX.Element => {
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()
  const optionListUsages = useOptionListUsages("long")

  const selectItem = React.useCallback(
    (optionList: IOptionList): void => navigate(catalogNavigation.editPath("option_list", optionList.id)),
    [catalogNavigation, navigate],
  )

  const moveItem: NavigatorProps<IOptionList>["moveItem"] = React.useCallback(
    (item, newPosition) => editor.optionList.move(item, newPosition),
    [editor],
  )

  const renderItem: ItemRenderFunction<IOptionList> = React.useCallback(
    (optionList, itemRenderProps) => {
      return (
        <StyledOptionList {...itemRenderProps}>
          <Name>
            {optionList.name}
            <Usage isSelected={itemRenderProps.isSelected}>{optionListUsages(optionList)}</Usage>
          </Name>
          <MoveHandle {...itemRenderProps} />
        </StyledOptionList>
      )
    },
    [optionListUsages],
  )

  return <OptionListNavigator {...{ items, selectItem, selectedId, moveItem, renderItem }} />
}

export default Navigator
